/**
 * Centro e zoom padrão dos mapas (EPSG:3857).
 * Valores vêm de window.mapDefaults, definido no layout a partir da personalização.
 */
function resolveMapDefaults() {
    const fromWindow = typeof window !== 'undefined' ? window.mapDefaults : null;
    const center = fromWindow?.center;
    const zoom = fromWindow?.zoom;

    return {
        center: Array.isArray(center) && center.length === 2
            ? [Number(center[0]), Number(center[1])]
            : [-5582481.3, -3505987.0],
        zoom: Number.isFinite(Number(zoom)) ? Number(zoom) : 14,
    };
}

export function getDefaultMapCenter() {
    return [...resolveMapDefaults().center];
}

export function getDefaultMapZoom() {
    return resolveMapDefaults().zoom;
}

export function getDefaultMapView(zoom = null) {
    const defaultInfo = resolveMapDefaults();

    return { center: [...defaultInfo.center], zoom: zoom ?? defaultInfo.zoom };
}

/** Zoom inicial na tela welcome (não usa MAP_DEFAULT_ZOOM do .env). */
export const WELCOME_MAP_ZOOM = 12;

export function getMapDefaultCenterView() {
    const { center } = resolveMapDefaults();
    return {
        center: [...center],
        zoom: WELCOME_MAP_ZOOM,
        minZoom: 5,
        maxZoom: 22,
    };
}
